export const deprecatedColorThemeConfig = {
    black: {
        primary: '#000',
        secondary: '#222228',
    },
    blue: {
        light: '#285AD3',
    },
    cement: {
        primary: '#d0cace',
    },
    completed: '#70bb1f',
    info: '#4a90e2',
    white: {
        primary: '#fff',
        secondary: '#fafafa',
    },
    gray: {
        background: '#f5f5f5',
        lightest: '#eee',
        light: '#b2b2b2',
        medium: '#999',
        dark: '#666',
        darkest: '#333',
    },
    obsidian: '#282828',
    obsidianLight: '#525252',
    obsidianLighter: '#707070',
    red: {
        dark: '#c41e3a',
        error: '#c41e3a',
    },
    stone: '#CCCCCC',
    stoneDark: '#A3A3A3',
    stoneLight: '#E5E5E5',
    stoneLighter: '#F5F5F5',
    success: '#78AD36',
    successLight: '#E4EFD7',
};
//# sourceMappingURL=deprecatedColors.js.map